import { Directive, Output, Input, EventEmitter, HostBinding, HostListener } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[wmtDragDrop]'
})
export class DragDropDirective {

    @Output() filesDropped = new EventEmitter<File[]>();
    @Input() dragEnabled? : boolean = true;

    @HostBinding('class.dragover') dragover: boolean;

    private dragCounter = 0;

    @HostListener('dragenter', ['$event'])
    onDragEnter(evt: DragEvent) {
        if (!this.dragEnabled) {
            return;
        }
        evt.preventDefault();
        evt.stopPropagation();
        this.dragCounter++;
        this.dragover = true;
    }

    @HostListener('dragover', ['$event']) onDragOver(evt: DragEvent) {
        if (!this.dragEnabled) {
            return;
        }
        evt.preventDefault();
        evt.stopPropagation();
        this.dragover = true;
    }

    @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent) {
        if (!this.dragEnabled) {
            return;
        }
        evt.preventDefault();
        evt.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter === 0) {
          this.dragover = false;
        }
    }

    @HostListener('drop', ['$event']) public ondrop(evt: DragEvent) {
        if (!this.dragEnabled) {
            return;
        }
        evt.preventDefault();
        evt.stopPropagation();
        this.dragCounter = 0;
        this.dragover = false;
        const fileList = evt.dataTransfer?.files
        const files = fileList ? Array.from(fileList) : [];
        if (files.length > 0) {
          this.filesDropped.emit(files);
        }
    }

}
